import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable()
export class AddBenefitService {
  private http = inject(HttpClient);
  private url = Global.url;

  createBenefit(params: any): Observable<any> {
    return this.http.post(this.url + 'V1/benefits', params);
  }
}
